import React, { useState } from 'react';
import { ScreenName, Store, CartItem, Gift as GiftType } from './types';
import { MOCK_USER } from './data/mockData';
import { ToastProvider } from './components/ToastContext';
import { BottomNav } from './components/BottomNav';
// Screens
import { HomeScreen } from './components/screens/HomeScreen';
import { ExploreScreen } from './components/screens/ExploreScreen';
import { StoreProfileScreen } from './components/screens/StoreProfileScreen';
import { MenuScreen } from './components/screens/MenuScreen';
import { CheckoutScreen } from './components/screens/CheckoutScreen';
import { OrdersScreen } from './components/screens/OrdersScreen';
import { GiftingScreen } from './components/screens/GiftingScreen';
import { GiftHistoryScreen } from './components/screens/GiftHistoryScreen';
import { GiftRedeemScreen } from './components/screens/GiftRedeemScreen';
import { ProfileScreen } from './components/screens/ProfileScreen';
import { CheckInSuccessScreen } from './components/screens/CheckInSuccessScreen';
export function App() {
  const [currentScreen, setCurrentScreen] = useState<ScreenName>('home');
  const [selectedStore, setSelectedStore] = useState<Store | null>(null);
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [selectedGift, setSelectedGift] = useState<GiftType | null>(null);
  const navigateTo = (screen: ScreenName, data?: any) => {
    window.scrollTo(0, 0);
    if (screen === 'gift-redeem' && data) {
      setSelectedGift(data);
    }
    setCurrentScreen(screen);
  };
  const handleStoreClick = (store: Store) => {
    setSelectedStore(store);
    navigateTo('store-profile');
  };
  const handleViewMenu = () => {
    navigateTo('menu');
  };
  const handleCheckout = (items: CartItem[]) => {
    setCartItems(items);
    navigateTo('checkout');
  };
  const handlePlaceOrder = () => {
    setCartItems([]);
    navigateTo('orders');
  };
  const handleCheckIn = () => {
    navigateTo('check-in-success');
  };
  const renderScreen = () => {
    switch (currentScreen) {
      case 'home':
        return <HomeScreen user={MOCK_USER} onNavigate={navigateTo} onStoreClick={handleStoreClick} data-id="element-0" />;
      case 'explore':
        return <ExploreScreen onStoreClick={handleStoreClick} data-id="element-1" />;
      case 'store-profile':
        return selectedStore ? <StoreProfileScreen store={selectedStore} onBack={() => navigateTo('explore')} onViewMenu={handleViewMenu} onCheckIn={handleCheckIn} data-id="element-2" /> : null;
      case 'menu':
        return selectedStore ? <MenuScreen store={selectedStore} onBack={() => navigateTo('store-profile')} onCheckout={handleCheckout} data-id="element-3" /> : null;
      case 'checkout':
        return <CheckoutScreen items={cartItems} total={cartItems.reduce((sum, i) => sum + i.price * i.quantity, 0)} onBack={() => navigateTo('menu')} onPlaceOrder={handlePlaceOrder} data-id="element-4" />;
      case 'orders':
        return <OrdersScreen data-id="element-5" />;
      case 'gifting':
        return <GiftingScreen onNavigate={navigateTo} data-id="element-6" />;
      case 'gift-history':
        return <GiftHistoryScreen onBack={() => navigateTo('gifting')} onRedeem={gift => navigateTo('gift-redeem', gift)} data-id="element-7" />;
      case 'gift-redeem':
        return selectedGift ? <GiftRedeemScreen gift={selectedGift} onBack={() => navigateTo('gift-history')} data-id="element-8" /> : null;
      case 'profile':
        return <ProfileScreen user={MOCK_USER} data-id="element-9" />;
      case 'check-in-success':
        return selectedStore ? <CheckInSuccessScreen store={selectedStore} onDismiss={() => navigateTo('explore')} data-id="element-10" /> : null;
      default:
        return <HomeScreen user={MOCK_USER} onNavigate={navigateTo} onStoreClick={handleStoreClick} data-id="element-11" />;
    }
  };
  return <ToastProvider data-id="element-12">
      <div className="min-h-screen bg-gray-100 flex justify-center" data-id="element-13">
        <div className="w-full max-w-md bg-white shadow-2xl rounded-2xl min-h-screen relative overflow-hidden" data-id="element-14">
          {renderScreen()}

          {/* Hide BottomNav on full-screen flows */}
          {!['check-in-success', 'gift-redeem', 'menu', 'checkout'].includes(currentScreen) && <BottomNav currentScreen={currentScreen} onNavigate={navigateTo} data-id="element-15" />}
        </div>
      </div>
    </ToastProvider>;
}